import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation archiveStoreMutation($input: ArchiveStoreInput!) {
    archiveStore(input: $input) {
      store {
        state
      }
    }
  }
`;

const archiveStore = (environment, storeId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: {
        id: storeId,
      },
    },

    ...args,
  });
};

export default archiveStore;
